export const emDash = '—';
export const enDash = '–';
export const ellipsis = '…';
export const ethSymbol = 'Ξ';
